import { makeStyles, TableCell, TableRow, withStyles } from '@material-ui/core';
import { themeColor } from '../../../mui-theme';
import { vh } from 'src/common/helpers/dimension-helper';

const lineBase = {
  color: themeColor.defaultTextColor,
  letterSpacing: '0.01vw',
  lineHeight: '3.12vh',
  fontSize: vh(2.08),
  fontWeight: 500,
  borderBottom: `1px solid ${themeColor.secondaryLight}`,
  cursor: 'pointer',
  '& :not(:last-item)': {
    borderBottom: 'none',
  },
};

export const styles = makeStyles(theme => ({
  tableRoot: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
}));

export const StyledTableCell = withStyles(() => ({
  root: {
    ...lineBase,
    paddingLeft: 10,
    paddingBottom: 0,
    paddingTop: 0,
  },
}))(TableCell);

export const StyledTableRow = withStyles(() => ({
  root: {
    ...lineBase,
    '&.Mui-selected': {
      backgroundColor: themeColor.selectedPrimary,
      '&:hover': {
        backgroundColor: themeColor.selectedPrimary,
      },
    },
  },
}))(TableRow);
